import React, { useState, useEffect } from "react";
import { withRouter, Redirect, Link } from "react-router-dom";
import { message, Form, Input, Card, Button, Modal } from "antd";
import {
  MailOutlined,
  LockOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { onLanguageChange } from "../../Redux/Actions/LanguageActions";
import { APIRequest, LoginUser, SignupUser } from "../../Utils/APIManager";
import { ROUTES } from "../../Router/RouteConstant";
import "../../CustomStyles/customStyle.css";
import background_logout from "../../assets/background_logout.jpg";
import toggle_active from "../../assets/toggle_active.png";
import toggle_inactive from "../../assets/toggle_inactive.png";
import {
  STR_WelcomeEnglish,
  STR_WelcomeTamil,
  STR_Email,
  STR_Tam_Email,
  STR_Password,
  STR_Tam_Password,
  STR_ForgetPassword,
  STR_Tam_ForgetPassword,
  STR_Login,
  STR_Tam_Login,
  STR_EmailEmpty,
  STR_Tam_EmailEmpty,
  STR_PasswordEmpty,
  STR_Tam_PasswordEmpty,
  STR_TAM_Error,
  STR_Error,
  STR_TAM_Error_Result,
  STR_Error_Result,
  STR_Tam_EmailValid,
  STR_EmailValid,
  STR_Tam_TC,
  STR_Tc,
  STR_Tam_PP,
  STR_PP,
  STR_TAMIL_Disclaimer,
  STR_Disclaimer,
  STR_Tam_BySignin,
  STR_BySignin,
  STR_SignupContentEnglish,
  STR_SignupContentTamil,
} from "../../Config.js/Strings";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loadingVisible: false,
      language: "TAMIL",
      login_type: "NORMAL",
      google_id: "",
      first_name: "",
      last_name: "",
      conform_password: "",
      loadingBtn: false,
    };
  }

  componentDidMount() {
    let isTamil = localStorage.getItem("agarathi_isTamil");
    if (isTamil === "null" || !isTamil) {
      localStorage.setItem("agarathi_isTamil", "true");
      isTamil = "true";
    }
    if (isTamil === "false") {
      this.props.onLanguageChange(false);
    } else {
      this.props.onLanguageChange(true);
    }
  }

  handleToggle = () => {
    const { isTamil } = this.props.LanguageReducer;
    const newValue = !isTamil;
    this.props.onLanguageChange(newValue);
    localStorage.setItem("agarathi_isTamil", newValue.toString());
  };

  handleSubmit = async (values, setSubmitting) => {
    try {
      this.setState({ loadingVisible: true });
      const { isTamil } = this.props.LanguageReducer;

      const language = isTamil ? "true" : "false";
      localStorage.setItem("agarathi_isTamil", language);

      const inputData = {
        email: values.email,
        password: values.password,
        language: isTamil ? "TAMIL" : "ENGLISH",
        login_type: this.state.login_type,
      };

      message.destroy();
      APIRequest.getPostService(LoginUser, inputData)
        .then((result) => {
          if (result.status === 1) {
            localStorage.setItem("agarathi_token", result.data.token);
            localStorage.setItem(
              "getUserDetails",
              JSON.stringify(result.data.userDetails)
            );
          } else if (result.status) {
            message.success(result.message);
            this.props.history.replace({
              pathname: ROUTES.VERIFICATION_PAGE,
              search: `?email=${inputData.email}`,
              state: { isTamil },
            });
          } else if (result.status === false) {
            setSubmitting(false);
            message.error(isTamil ? STR_TAM_Error_Result : STR_Error_Result);
          }
          setSubmitting(false);
          this.setState({ loadingVisible: false });
        })
        .catch((error) => {
          this.setState({ loadingVisible: false });
          setSubmitting(false);
          if (error.message) {
            message.error(error.message);
          } else if (error.data) {
            message.error(isTamil ? STR_TAM_Error : STR_Error);
          } else {
            message.error(error);
          }
        });
    } catch (error) {
      setSubmitting(false);
      this.setState({ loadingVisible: false });
    }
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  responseGoogle = (response) => {
    const { isTamil } = this.props.LanguageReducer;
    var language = isTamil ? "TAMIL" : "ENGLISH";
    var profileData = response.profileObj;

    if (!response.error) {
      this.setState({ loadingVisible: true });
      message.destroy();
      let data = {
        email: profileData.email,
        language: language,
        login_type: "GOOGLE",
        google_id: profileData.googleId,
        loadingVisible: true,
        first_name: profileData.givenName,
        last_name: profileData.familyName,
        signup_type: "google",
        password: "Agarathi@123",
        conform_password: "Agarathi@123",
      };
      this.setState({ data });
      APIRequest.getPostService(SignupUser, data)
        .then((result) => {
          if (result.status) {
            message.success(result.message);
            localStorage.setItem("agarathi_token", result.data.token);
            localStorage.setItem(
              "agarathi_userDetails",
              JSON.stringify(result.data.userDetails)
            );
            localStorage.setItem(
              "agarathi_first_name",
              result.data.userDetails.first_name
            );
            localStorage.setItem(
              "agarathi_last_name",
              result.data.userDetails.last_name
            );
            localStorage.setItem(
              "agarathi_email",
              result.data.userDetails.email
            );
          }
        })
        .catch((error) => {
          this.setState({
            loadingVisible: false,
          });
          if (error.message) {
            message.error(error.message);
          } else if (error.data) {
            message.error(error.data.message);
          } else {
            message.error(error);
          }
        }, 2000);
    }
  };

  render() {
    const { open, onClose } = this.props;
    const { isTamil } = this.props.LanguageReducer;
    const token = localStorage.getItem("agarathi_token");

    if (token) return <Redirect to={{ pathname: ROUTES.LAYOUT }} />;

    return (
      <Modal
        title=""
        className="login_popupmodal"
        open={open}
        onCancel={onClose}
        footer={null}
        centered
        width={750}
        bodyStyle={{ padding: 0, borderRadius: "20px" }}
      >
        <div className="flex flex-col lg:flex-row items-center justify-center bg-white rounded-2xl overflow-hidden">
          {/* Right form section */}
          <div className="card_background w-full lg:w-1/2 p-8 ">
            <Card
              bordered={false}
              style={{ boxShadow: "none" }}
              className="w-full bg-transparent form_card form-scroll-container"
            >
              <Formik
                initialValues={{ email: "", password: "" }}
                validationSchema={Yup.object().shape({
                  email: Yup.string().required().email("invalid"),
                  password: Yup.string().required(),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  this.handleSubmit(values, setSubmitting);
                }}
              >
                {({
                  setFieldValue,
                  errors,
                  handleSubmit,
                  values,
                  isSubmitting,
                  touched,
                  dirty,
                }) => (
                  <Form layout="vertical form_input">
                    <div className="logoswitch" style={{ textAlign: "right" }}>
                      {/* Custom Toggle Button */}
                      <button
                        onClick={this.handleToggle}
                        style={{
                          background: "white",
                          borderRadius: "50%",
                          width: "52px",
                          height: "50px",
                          border: "none",
                          cursor: "pointer",
                          boxShadow: "0 0 8px rgba(0,0,0,0.15)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={isTamil ? toggle_inactive : toggle_active}
                          alt="Language Toggle"
                          style={{
                            width: "30px",
                            height: "30px",
                            transition: "transform 0.2s ease",
                          }}
                        />
                      </button>
                    </div>

                    <h1 className="font-semibold text-xl mt-2 mb-6 text-center">
                      {isTamil ? STR_WelcomeTamil : STR_WelcomeEnglish}
                    </h1>

                    {/* Email Field */}
                    <Form.Item name="email" style={{ marginBottom: "5px" }}>
                      <Input
                        prefix={<MailOutlined />}
                        style={{
                          borderRadius: "10px",
                          fontSize: "12px",
                          height: "45px",
                        }}
                        id="email"
                        status={errors.email && touched.email ? "error" : ""}
                        autoComplete="off"
                        onChange={(e) => setFieldValue("email", e.target.value)}
                        type="text"
                        placeholder={isTamil ? STR_Tam_Email : STR_Email}
                        name="email"
                      />
                    </Form.Item>
                    {errors.email && touched.email && (
                      <span className="err-msg">
                        {errors.email === "invalid"
                          ? isTamil
                            ? STR_Tam_EmailValid
                            : STR_EmailValid
                          : isTamil
                          ? STR_Tam_EmailEmpty
                          : STR_EmailEmpty}
                      </span>
                    )}

                    {/* Password Field */}
                    <div className="mt-5">
                      <Form.Item style={{ marginBottom: "5px" }}>
                        <Input.Password
                          prefix={<LockOutlined />}
                          style={{ borderRadius: "10px", height: "45px" }}
                          id="password"
                          type="password"
                          status={
                            errors.password && touched.password ? "error" : ""
                          }
                          autoComplete="off"
                          onChange={(e) =>
                            setFieldValue("password", e.target.value)
                          }
                          placeholder={
                            isTamil ? STR_Tam_Password : STR_Password
                          }
                          name="password"
                          iconRender={(visible) =>
                            visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                          }
                          maxLength={14}
                        />
                      </Form.Item>
                      {errors.password && touched.password && (
                        <span className="err-msg">
                          {isTamil ? STR_Tam_PasswordEmpty : STR_PasswordEmpty}
                        </span>
                      )}
                    </div>

                    <div className="flex items-center justify-end w-full mt-2">
                      <span
                        className="font-semibold underline"
                        style={{
                          color: "#35A6C9",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          onClose(); // close login modal
                          window.dispatchEvent(new Event("openForgotPopup")); // trigger forgot password modal
                        }}
                      >
                        {isTamil ? STR_Tam_ForgetPassword : STR_ForgetPassword}
                      </span>
                    </div>

                    {/* Submit Button */}
                    <Button
                      disabled={isSubmitting}
                      loading={isSubmitting}
                      style={{
                        backgroundColor: "#0FA6C9",
                        borderRadius: "8px",
                        height: "40px",
                        width: "280px",
                        marginLeft: "50px",
                      }}
                      type={!dirty ? "default" : "primary"}
                      onClick={handleSubmit}
                      className="login-btn mt-4 text-white font-semibold px-4 rounded-full shadow-sm w-full"
                    >
                      {isTamil ? STR_Tam_Login : STR_Login}
                    </Button>

                    {/* Signup Link */}
                    {/* <div className="flex items-center justify-center w-full mt-4">
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <Link
                          className="inline-block underline text-blue-500 align-baseline font-semibold text-sm text-purple-600 hover:text-white"
                          to={ROUTES.SIGNUP}
                          id={"newaccont-link"}
                          style={{ color: "#35A6C9" }}
                        >
                          {isTamil
                            ? STR_SignupContentTamil
                            : STR_SignupContentEnglish}
                        </Link>
                      </span>
                    </div> */}
                    {/* Signup Link */}
                    <div className="flex items-center justify-center w-full mt-4">
                      <span
                        className="font-semibold underline"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#35A6C9",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          onClose(); // close login modal
                          window.dispatchEvent(new Event("openSignupPopup")); // open signup modal
                        }}
                      >
                        {isTamil
                          ? STR_SignupContentTamil
                          : STR_SignupContentEnglish}
                      </span>
                    </div>
                    {/* Terms & Disclaimer */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "80%",
                        marginLeft: "3rem",
                      }}
                    >
                      <div
                        className="BySignin"
                        style={{
                          textAlign: "center",
                          marginTop: "1rem",
                        }}
                      >
                        {isTamil ? STR_Tam_BySignin : STR_BySignin}
                      </div>

                      <div
                        style={{
                          textAlign: "center",
                          gap: "0.5px",
                        }}
                      >
                        <Link
                          id={"newaccont-link"}
                          to={"/terms_and_conditions"}
                        >
                          {isTamil ? STR_Tam_TC : STR_Tc}
                        </Link>
                        {", "}
                        <Link id={"newaccont-link"} to={"/privacy_policy"}>
                          {isTamil ? STR_Tam_PP : STR_PP}
                        </Link>
                        {", "}
                        <Link id={"newaccont-link"} to={"/disclaimer_1"}>
                          {isTamil ? STR_TAMIL_Disclaimer : STR_Disclaimer}
                        </Link>
                      </div>

                      <div
                        className="BySignin"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {isTamil ? "ஆகியவற்றை ஒப்புக்கொள்கிறீர்கள்." : null}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  LanguageReducer: state.LanguageReducer,
});

const mapDispatchToProps = (dispatch) => ({
  onLanguageChange: (language) => dispatch(onLanguageChange(language)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
